import React from 'react';

export const BTitle = (props) => {
  const { text, className = '' } = props;
  return (
    <span className={`btitle ${className}`}>
      {text}
      <span className="dot">.</span>
    </span>
  );
};

export default BTitle;
